import { ITag } from '@forwardflow/store/onboardingStoreV2'
import {
   IStageMapGroup,
   IStageMappingSubGroup,
   ITempStageGroup,
   TStageGroupId,
   TStopStageKey,
} from '@forwardflow/types/onboarding'

export const transformStageMappingData = (data: ITempStageGroup[]) => {
   const stageMappings: IStageMapGroup[] = []
   const parentGroups = data.filter((item) => !item.parentGroupId)
   parentGroups.forEach((item) => {
      const stages = item?.stageOrTags?.filter(
         (item) => item.type === 'stage' && !!item.name && !!item.id
      )
      const tags = item?.stageOrTags?.filter(
         (item) => item.type === 'tag' && !!item.name
      )

      stageMappings.push({
         group: item.groupId as TStageGroupId,
         stages: stages,
         tags: tags as ITag[],
         ...(item.type ? { type: item?.type } : {}),
      })
   })

   const childGroups = data
      .filter((item) => item.parentGroupId === 'ff-stopped')
      ?.map((i) => ({
         key: i.groupId as TStopStageKey,
         stages: i?.stageOrTags?.filter((item) => item.type === 'stage'),
         tags: i?.stageOrTags?.filter((item) => item.type === 'tag'),
      }))

   stageMappings.push({
      group: 'ff-stopped',
      types: childGroups as IStageMappingSubGroup[],
   })
   return stageMappings
}

export const transformStageMappingDataToTempStageGroups = (data: IStageMapGroup[]) => {
   const tempStageGroups: ITempStageGroup[] = []

   data.forEach((item) => {
      if (item?.group === 'ff-stopped' && item?.types && item?.types?.length > 0) {
         // Handle child groups with parentGroupId
         item?.types?.forEach((subGroup) => {
            const stageOrTags = [
               ...(subGroup?.stages || []),
               ...(subGroup?.tags || []),
            ]

            tempStageGroups.push({
               groupId: subGroup.key,
               parentGroupId: 'ff-stopped',
               stageOrTags: stageOrTags,
            })
         })
      } else {
         // Handle parent groups
         const stageOrTags = [
            ...(item.stages || []),
            ...(item.tags || []),
         ]

         tempStageGroups.push({
            groupId: item.group,
            parentGroupId: null,
            stageOrTags: stageOrTags,
            ...(item.type ? { type: item.type } : {}),
         })
      }
   })

   return tempStageGroups
}
